import { Paper, Typography } from "@material-ui/core";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { useAuth } from "@ofqual/portal-core/core/hooks";
import React from "react";
import { SocItem } from "../../domain/SocItem";
import { authSelector } from "../../redux/selectors";
import { UserType } from "../../redux/types";
import { CurrentCompliance } from "../sections/CurrentCompliance";
import { Epa } from "../sections/Epa";
import { FutureCompliance } from "../sections/FutureCompliance";
import { GoverningBodySignoff } from "../sections/GoverningBodySignoff";
import { OrganisationalStability } from "../sections/OrganisationalStability/OrganisationalStability";
import { RegulatorsToNotify } from "../sections/RegulatorsToNotify";
import { SectionProps } from "../sections/SectionProps";
import { ThirdPartyArrangements } from "../sections/ThirdPartyArrangements";

const useStyles = makeStyles((theme) => ({
  formHeading: {
    color: "#9f9f9f",
    fontSize: "1em",
    marginBottom: "30px",
    fontWeight: 600,
    position: "relative",
  },
  formSection: {
    padding: 30,
    boxShadow: "0 0 19px -2px hsla(0,0%,63.9%,.3)",
    border: "1px solid #ddd",
    backgroundColor: "#fff",
    borderRadius: "3px",
  },
}));

export const ItemDetails: React.FC<{
  sectionProps: SectionProps<SocItem>;
}> = ({ sectionProps }) => {
  const classes = useStyles();
  const { userType } = useAuth(authSelector);

  const isAoFormDisabled = userType !== UserType.AO || sectionProps.disabled;
  return (
    <div>
      <Typography variant="h6">Regulators to Notify</Typography>

      <Paper className={classes.formSection}>
        <RegulatorsToNotify {...sectionProps} disabled={isAoFormDisabled} />
      </Paper>

      <Typography variant="h6">Declaration of current compliance</Typography>

      <Paper className={classes.formSection}>
        <CurrentCompliance {...sectionProps} disabled={isAoFormDisabled} />
      </Paper>

      <Typography variant="h6">Declaration of future compliance</Typography>

      <Paper className={classes.formSection}>
        <FutureCompliance {...sectionProps} disabled={isAoFormDisabled} />
      </Paper>

      <Typography variant="h6">Organisational stability</Typography>

      <Paper className={classes.formSection}>
        <OrganisationalStability
          {...sectionProps}
          disabled={isAoFormDisabled}
        />
      </Paper>

      <Typography variant="h6">Third party arrangements, including conflict of interest</Typography>
      <Paper className={classes.formSection}>
        <ThirdPartyArrangements
          {...sectionProps}
          disabled={isAoFormDisabled}
        />
      </Paper>

      <Typography variant="h6">Apprenticeship end-point assessments</Typography>

      <Paper className={classes.formSection}>
        <Epa {...sectionProps} disabled={isAoFormDisabled} />
      </Paper>

      <Typography variant="h6">
        Declaration of governing body sign-off
      </Typography>
      <Paper className={classes.formSection}>
        <GoverningBodySignoff {...sectionProps } disabled={isAoFormDisabled}/>
      </Paper>
    </div>
  );
};
